var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-card',{attrs:{"title":"個人資訊"}},[_c('v-card-text',[_c('teacher-profile-info',{attrs:{"profile":_vm.selfTeacherProfile}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }